import MeetingRequestCalendly from "components/dashboard/MeetingRequestCalendly";
import Modal from "components/DesignSystem/Modal/Modal";
import React from "react";
import { ModalProps } from "types/utils/modal";

export const CalendlyModal = ({
  isOpen,
  close,
  calendlyLink,
  title = "",
}: ModalProps & { calendlyLink: string; title?: string }) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="xxl">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <MeetingRequestCalendly calendlyLink={calendlyLink} />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
